import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'daysleft',
    standalone: false
})
export class RemainingDaysPipe implements PipeTransform {
	curDate: Date;
	transform(startDate?: any, endDate?: any): any {
		if (moment(this.curDate).format('YYYY-MM-DD hh:mm') <= moment(endDate).format('YYYY-MM-DD hh:mm')) {

			// var endDateTime =new Date(endDate.replace(" ","T"));
			// var date_now = new Date();
			// var delta = Math.abs(+endDateTime - +date_now) / 1000;
			// var days = Math.floor(delta / 86400);
			// if (days > 0) return days + ' days ';
			// delta -= days * 86400;
			// var hours = Math.floor(delta / 3600) % 24;
			// if (hours > 1) return hours + ' Hours ';
			// delta -= hours * 3600;
			// var minutes = Math.floor(delta / 60) % 60;
			// delta -= minutes * 60;
			// var mins = ((days * 24 * 60) + (hours * 60) + minutes) + ' MINS ';
			// return mins;

			var endDateTime = new Date(endDate.replace(" ", "T"));
			var dateNow = new Date();
			var delta = Math.abs(+endDateTime - +dateNow) / 1000;
			var hours = Math.floor(delta / 3600);
			if (hours > 1) {
				return hours + ' Hours ';
			}
			var minutes = Math.floor(delta / 60);
			if (minutes > 1) {
				return minutes + ' MINS ';
			}

		}
		else return '0 Mins ';
	}
}